import Vue from 'vue';
import Vuex from 'vuex';
import { apiGetCourseAskUrl, apiGetInformation } from '@/api/API';
import campCart from './modules/campCart';
import courseCart from './modules/courseCart';
import campUnpaidOrder from './modules/campUnpaidOrder';
import memberNotification from './modules/memberNotification';

Vue.use(Vuex);

// 舊寫法：FilePath / WebSite 直接寫死 'https://extension.fcu.edu.tw/Extension2026/'。
// 本機前台 -> http://localhost:8080/files/...
// demo 前後台 -> http://demo.artinuro.com/extension2026/files/...
// 正式前後台 -> https://extension.fcu.edu.tw/Extension2026/files/...
const officialSiteUrl = 'https://extension.fcu.edu.tw/Extension2026/';
const configuredLocalSiteUrl = process.env.VUE_APP_SITE_URL || 'http://localhost:8080/';
const localSiteUrl = `${configuredLocalSiteUrl.replace(/\/+$/, '')}/`;
const demoSiteUrl = 'http://demo.artinuro.com/extension2026/';

function getSiteUrl() {
    if (process.env.NODE_ENV === 'development') {
        return localSiteUrl;
    }

    if (typeof window !== 'undefined') {
        if (window.location.host.includes('demo.artinuro.com')) {
            return demoSiteUrl;
        }
    }

    return officialSiteUrl;
}

const siteUrl = getSiteUrl();

export default new Vuex.Store({
    state: {
        FilePath: siteUrl,
        // 舊寫法：FilePath: 'https://extension.fcu.edu.tw/Extension2026/',
        // FilePath: '',
        accountData: '',
        datas: {},
        OrderNo: '',
        Param: {
            Paging: {
                pageNumber: 1,
                pageSize: 10,
            },
            Search: {
                keywords: '',
            },
        },
        AllParam: {
            Paging: {
                pageNumber: 1,
                pageSize: 99999,
            },
            Search: {
                keywords: '',
            },
        },
        WebSite: siteUrl,
        // 舊寫法：WebSite: 'https://extension.fcu.edu.tw/Extension2026/',
        courseAskUrl: '',
        campLineUrl: '',
    },
    mutations: {
        setaccountData(state, data) {
            state.accountData = data;
        },
        _datas(state, data) {
            state.datas = data;
        },
        setOrderNo(state, data) {
            state.OrderNo = data;
        },
        setCourseAskUrl(state, url) {
            state.courseAskUrl = url || '';
        },
        setCampLineUrl(state, url) {
            state.campLineUrl = url || '';
        },
    },
    actions: {
        async loadCourseAskUrl({ commit }) {
            try {
                const { data } = await apiGetCourseAskUrl();
                const url = Array.isArray(data) ? data[0] || '' : typeof data === 'string' ? data : data?.url || '';
                commit('setCourseAskUrl', url);
            } catch (e) {
                commit('setCourseAskUrl', '');
            }
        },
        async loadCampLineUrl({ commit }) {
            try {
                const { data } = await apiGetInformation('camp_line_contact');
                commit('setCampLineUrl', data?.Content || '');
            } catch (e) {
                commit('setCampLineUrl', '');
            }
        },
    },
    modules: { campCart, courseCart, campUnpaidOrder, memberNotification },
});
